module.exports = "/images/Closeout.svg";